<template>
  <div class="survey-list">
    <div class="user-disp">
      <h2>
        <span>{{ user.fullName }}</span> - {{ parseTranslation(SURVEY_LIST) }}
      </h2>
    </div>
    <div v-if="surveys.length" class="survey-container">
      <div class="wrapper">
        <div class="name">
          <h2>{{ parseTranslation(SURVEY_NAME) }}</h2>
        </div>
        <div class="options">
          <h2>{{ parseTranslation(CHANGE_SURVEY_OWNER) }}</h2>
        </div>
      </div>
      <survey-change
        v-for="surv in orderedSurveys"
        @changed="$emit('selectedUser', user)"
        :key="surv._id"
        :survey="surv"
        :users="users.filter(val => val !== user)"
      />
    </div>
    <div v-else class="no-informations">
      {{ parseTranslation(NO_USER) }}
    </div>
  </div>
</template>

<script>
import SurveyChange from './SurveyChange'

import * as translationSurveyList from './SurveyList.translations'
const { default: translations, ...translationKeys } = translationSurveyList

export default {
  name: 'surveylist',

  data() {
    return {
      translations,
      ...translationKeys,
    }
  },

  props: {
    users: Array,
    user: {
      type: Object,
      required: true,
    },
    surveys: {
      type: Array,
      required: true,
    },
  },
  components: {
    SurveyChange,
  },
  computed: {
    // ordenar em ordem alfabética em um array em um v-for
    orderedSurveys() {
      function compare(a, b) {
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1
        return 0
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.surveys.sort(compare)
    },
  },
}
</script>

<style lang="scss" scoped>
.user-disp {
  display: flex;
  justify-content: center;
  h2 {
    @include tipography(18);
    height: 20px;
    text-align: center;
    span {
      font-weight: bold;
    }
  }
  .light & {
    h2 {
      color: $gray-6;
    }
  }
}

.survey-list {
  width: 100%;
  height: auto;

  .no-informations {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 50px;
    @include tipography(18);

    .light & {
      color: $gray-6;
      font-weight: bold;
    }
  }
}

.survey-container {
  width: 100%;
  border-radius: 2px;
  div.wrapper {
    display: flex;
    justify-content: space-around;
    margin-bottom: 20px;
    .name {
      flex: 1;
      h2 {
        text-align: center;
        margin: 30px 0 0;
        @include tipography(20);
      }
    }
    .options {
      flex: 1;
      h2 {
        text-align: center;
        margin: 30px 0 0;
        @include tipography(20);
      }
    }
  }
  .light & {
    div.wrapper {
      .name {
        h2 {
          color: $gray-6;
        }
      }
      .options {
        h2 {
          color: $gray-6;
        }
      }
    }
  }
}
</style>
